import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { Switch } from '../buttons/Swtich';
import { LocalStorage } from '../../utils/LocalStorage';

class TableExportControlsComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            heatMapEnabled: LocalStorage.getHeatMapEnabled(),
        };
        this.handleHeatMapToggle = this.handleHeatMapToggle.bind(this);
    }

    handleHeatMapToggle(event) {
        const enabled = event.target.checked;
        this.setState({ heatMapEnabled: enabled });
        LocalStorage.saveHeatMapEnabled(enabled);

        if (this.props.onHeatMapToggle) {
            this.props.onHeatMapToggle(enabled);
        }
    }

    render() {
        const { t } = this.props;

        return (
            <div className="chart-controls">
                <div className="chart-controls__action-buttons" style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: '15px' }}>
                    <div
                        className="chart-controls__adjust-menu-option"
                        style={{
                            padding: '7px',
                            backgroundColor: '#f8f9fa',
                            borderRadius: '5px',
                            display: 'flex',
                            alignItems: 'center',
                            cursor: 'default',
                        }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div style={{ display: 'flex', alignItems: 'center', height: '22px' }}>
                            <Switch
                                name="heatMapEnabled"
                                checked={this.state.heatMapEnabled}
                                onChange={this.handleHeatMapToggle}
                                style={{ margin: 0, marginLeft: 0 }}
                            />
                        </div>
                        <label
                            style={{
                                marginLeft: '10px',
                                marginBottom: 0,
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                flex: 1,
                            }}
                            onClick={(e) => {
                                e.stopPropagation();
                                this.handleHeatMapToggle({ target: { checked: !this.state.heatMapEnabled } });
                            }}
                        >
                            {t('data_explorer.show_heat_map_in_metrics_columns', 'Mostrar mapa de calor en las métricas')}
                        </label>
                    </div>
                </div>
            </div>
        );
    }
}

export const TableExportControls = withTranslation()(TableExportControlsComponent);
